// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1DcDA","additionalInfo":"AgreementModal_additionalInfo__1nDq1"};